import { render, staticRenderFns } from "./UIDatePicker.vue?vue&type=template&id=756854aa&scoped=true"
import script from "./UIDatePicker.vue?vue&type=script&lang=js"
export * from "./UIDatePicker.vue?vue&type=script&lang=js"
import style0 from "./UIDatePicker.vue?vue&type=style&index=0&id=756854aa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756854aa",
  null
  
)

export default component.exports